import { Component, OnInit } from '@angular/core';
import { ErrorCms } from '../../interfaces/error-cms.interface';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'lmw-error-internal-server-error',
  templateUrl: './internal-server-error.component.html'
})
export class InternalServerErrorComponent implements OnInit {


  public errorCms: ErrorCms;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.errorCms = this.route.snapshot.data.cmsData;
  }

}
